import { makeStyles } from '@material-ui/core';
import { efesError } from '../../../../theme';

const useStyles = makeStyles(() => ({
  subTitleRow: {
    fontSize: '1rem',
    margin: '0.5rem 0',
  },
  minusIcon: {
    cursor: 'pointer',
    fontSize: 20,

  },
  removeIcon: {
    color: efesError,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  container: {
    marginBottom: 30,
  },
}));

export default useStyles;
